import { DbotEventDispatcher, DecisionContext, DecisionTypeHandler } from "../common/commonDomain";
import {
  DividendPowerOfAttorney,
  DividendPowerOfAttorneyForm,
} from "./dividendPowerOfAttorneyDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: DividendPowerOfAttorney,
): DividendPowerOfAttorneyForm {
  return new DividendPowerOfAttorneyForm(context, data);
}

export function applyForm(form: DividendPowerOfAttorneyForm): DividendPowerOfAttorney {
  return {
    type: DecisionType.dividendPowerOfAttorney,
    powerOfAttorneyFor: form.powerOfAttorneyFor.value,
    powerOfAttorneyLimit: form.boardDecidesMaxAmount.value
      ? undefined
      : form.powerOfAttorneyLimit.parsedValue,
    boardDecidesMaxAmount: form.boardDecidesMaxAmount.value,
  };
}

export function validate(form: DividendPowerOfAttorneyForm) {
  return form.validate();
}

export function isValid(form: DividendPowerOfAttorneyForm) {
  return form.isValid;
}

export const dividendPowerOfAttorneyHandler: DecisionTypeHandler<
  DecisionType.dividendPowerOfAttorney,
  DividendPowerOfAttorney,
  DividendPowerOfAttorneyForm
> = {
  type: DecisionType.dividendPowerOfAttorney,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
